import { withTranslation } from "react-i18next";
import styles from "./AddStaff.module.scss";
import { useMemo, useState } from "react";
import DepartmentSelectionModal from "./DepartmentSelectionModal";
import EmploymentRoleSelectionModal from "./EmploymentRoleSelectionModal";
import ReportsToSelectionModal from "./ReportsToSelectionModal";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import { MoreTagsFunction } from "accountOwner/pages/AddEvent/addEvents.functions";
import OfficeSelectionModal from "./OfficeSelectionModal";

export const SelectionDiv = ({
  heading,
  t,
  errors,
  value,
  modalOpenHandler,
}) => {
  return (
    <div className="c-field">
      <div className={" d-flex justify-content-between  "}>
        <label className={styles["c-field-label"]}>{heading}</label>
        <span className="link-btn" onClick={modalOpenHandler}>
          {t("staff.select")}
        </span>
      </div>
      <div className="c-form-control " style={{ position: "relative" }}>
        <span className="text-break word-break text-wrap">{value}</span>
      </div>
      {errors && <span className="error-msg">{errors}</span>}
    </div>
  );
};
export const OfficeSelectionAndModal = ({
  t,
  setState,
  states,
  isOfficeLoading,
  office_list,
  selectedoffices,
}) => {
  const [isOfficeModalOpen, setIsOfficeModalOpen] = useState(false);
  const [invitePopupOpen, setInvitePopupOpen] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 40,
      left: 40,
    });
    setter((prev) => !prev);
  };
  const { officeIds, errors } = states;
  return (
    <>
      <SelectionDiv
        heading="Office(s)"
        modalOpenHandler={() => {
          setIsOfficeModalOpen(true);
        }}
        t={t}
        errors={errors?.officeIds}
        value={
          officeIds?.length === 0 ? (
            "No office(s) selected"
          ) : (
            <>
              <MoreTagsFunction
                value={officeIds}
                styles={styles.link_new}
                clickHandler={(e) => handlePopupToggle(e, setInvitePopupOpen)}
                mapFn={(member) => member?.name}
              />
              {invitePopupOpen && (
                <InviteesPopup
                  position={invitePopupPosition}
                  handleInvitePopupToggle={(e) =>
                    handlePopupToggle(e, setInvitePopupOpen)
                  }
                  list={officeIds}
                  isForEvent={true}
                  isfromBusySlot
                  onlyOfffice
                />
              )}
            </>
          )
        }
      />
      {isOfficeModalOpen && (
        <OfficeSelectionModal
          isModalOpen={isOfficeModalOpen}
          isOfficeLoading={isOfficeLoading}
          selectOfficeList={setState}
          selectedOffices={officeIds}
          office_list={office_list}
          setIsModalOpen={setIsOfficeModalOpen}
          selectedoffices={selectedoffices}
        />
      )}{" "}
    </>
  );
};
const SelectionAndModal = ({
  t,
  selectedOwnerId,
  designations,
  selectedDesignationOption,
  selectDesignationOption,
  designationError,
  officeId,
  setState,
  states,
  globalStaffPage,
  updateState,
  fieldValues,
  resetValues,
}) => {
  const [isDepartmentModalOpen, setIsDepartmentModalOpen] = useState(false);
  const [isReportsToModalOpen, setIsReportsToModalOpen] = useState(false);
  const [isEmploymentRoleModalOpen, setIsEmploymentRoleModalOpen] =
    useState(false);
  const { DepartmentId, ReportToId, officeIds } = states;
  const user = ReportToId?.user;
  const mappedOfficeIds = useMemo(
    () => officeIds.map((res) => res.id),
    [officeIds]
  );
  return (
    <>
      <SelectionDiv
        heading="Employment Role"
        modalOpenHandler={() => {
          setIsEmploymentRoleModalOpen(true);
        }}
        t={t}
        value={selectedDesignationOption?.name || "No role selected"}
        errors={designationError}
      />
      <SelectionDiv
        heading="Department/Team"
        modalOpenHandler={() => {
          setIsDepartmentModalOpen(true);
        }}
        t={t}
        value={DepartmentId?.name || "No department/team selected"}
      />
      {resetValues ? null : (
        <SelectionDiv
          heading="Reports To"
          modalOpenHandler={() => {
            setIsReportsToModalOpen(true);
          }}
          t={t}
          value={
            user
              ? (user?.firstName || "") + " " + (user?.lastName || "")
              : "No member selected"
          }
        />
      )}
      {isDepartmentModalOpen && (
        <DepartmentSelectionModal
          isModalOpen={isDepartmentModalOpen}
          setIsModalOpen={setIsDepartmentModalOpen}
          selectedOwnerId={selectedOwnerId}
          setSelectedDepartment={setState}
          preSelectedDepartement={DepartmentId}
          updateState={updateState}
          fieldValues={fieldValues}
        />
      )}
      {isEmploymentRoleModalOpen && (
        <EmploymentRoleSelectionModal
          isModalOpen={isEmploymentRoleModalOpen}
          setIsModalOpen={setIsEmploymentRoleModalOpen}
          designations={designations}
          selectedDesignationOption={selectedDesignationOption}
          selectDesignationOption={selectDesignationOption}
        />
      )}
      {isReportsToModalOpen && (
        <ReportsToSelectionModal
          setIsModalOpen={setIsReportsToModalOpen}
          isModalOpen={isReportsToModalOpen}
          ownerId={selectedOwnerId}
          officeId={globalStaffPage ? mappedOfficeIds : officeId}
          selectReportToStaffMember={setState}
          selectedReportsToStaff={ReportToId}
          globalStaffPage={globalStaffPage}
        />
      )}
    </>
  );
};
export default withTranslation()(SelectionAndModal);
